import { SaleType } from '~/apiClient';

export type SaleTypeInfo = {
    isMonoAsset: boolean;
    isBundle: boolean;
    isBundleMono: boolean;
    isBundleMulti: boolean;
    isMonoVersion: boolean;
    isToBeScraped: boolean;
};

export const getSaleTypeInfo = (saleType: SaleType): SaleTypeInfo => {
    const checkSaleType = (typeList: SaleType[]): boolean => typeList.includes(saleType);

    const isMonoAsset = checkSaleType([SaleType.Mono, SaleType.MonoToScrap]);
    const isBundleMono = checkSaleType([SaleType.BundleMonoVersion, SaleType.BundleMonoVersionToScrap]);
    const isBundleMulti = checkSaleType([SaleType.BundleMultiVersion, SaleType.BundleMultiVersionToScrap]);
    const isBundle = isBundleMono || isBundleMulti;
    const isMonoVersion = isMonoAsset || isBundleMono;
    const isToBeScraped = checkSaleType([SaleType.BundleMonoVersionToScrap, SaleType.BundleMultiVersionToScrap, SaleType.MonoToScrap]);

    return {
        isMonoAsset,
        isBundle,
        isBundleMono,
        isBundleMulti,
        isMonoVersion,
        isToBeScraped,
    };
};
